export type SidebarToolId =
  | 'budget'
  | 'wallet'
  | 'settings'
  | 'alerts'
  | 'commands'
  | 'scheduled'
  | 'campaigns'
  | 'creatives'
  | 'properties'

export const SIDEBAR_TOOL_ORDER: SidebarToolId[] = [
  'budget',
  'wallet',
  'settings',
  'alerts',
  'commands',
  'scheduled',
  'campaigns',
  'creatives',
  'properties',
]

export const DEFAULT_PINNED_SIDEBAR_TOOLS: SidebarToolId[] = [
  'budget',
  'wallet',
  'settings',
  'alerts',
  'commands',
  'scheduled',
]

export const SIDEBAR_PINNED_TOOLS_STORAGE_KEY = 'monarch.sidebarPinnedTools'

export type SidebarToolDef = {
  id: SidebarToolId
  label: string
  href: string
  prefetch?: boolean
  activeMatch?: (pathname: string) => boolean
}

export function orderPinnedSidebarTools(ids: SidebarToolId[]): SidebarToolId[] {
  const idSet = new Set(ids)
  return SIDEBAR_TOOL_ORDER.filter((id) => idSet.has(id))
}

export function readPinnedSidebarTools(): SidebarToolId[] {
  if (typeof window === 'undefined') return DEFAULT_PINNED_SIDEBAR_TOOLS
  try {
    const raw = localStorage.getItem(SIDEBAR_PINNED_TOOLS_STORAGE_KEY)
    if (!raw) return DEFAULT_PINNED_SIDEBAR_TOOLS
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return DEFAULT_PINNED_SIDEBAR_TOOLS
    const valid = parsed.filter(
      (id): id is SidebarToolId =>
        typeof id === 'string' && SIDEBAR_TOOL_ORDER.includes(id as SidebarToolId)
    )
    const ordered = orderPinnedSidebarTools(valid)
    return ordered.length > 0 ? ordered : DEFAULT_PINNED_SIDEBAR_TOOLS
  } catch {
    return DEFAULT_PINNED_SIDEBAR_TOOLS
  }
}

export function writePinnedSidebarTools(pinned: SidebarToolId[]): void {
  try {
    localStorage.setItem(SIDEBAR_PINNED_TOOLS_STORAGE_KEY, JSON.stringify(pinned))
  } catch {
    /* ignore */
  }
}
